import React from 'react';
import PropTypes from 'prop-types';
import ImageLoad from 'components/ImageLoad';
import Link from 'components/Link';
import TagManagerService from 'services/TagManager';

const Item = (props) => {
    const {
        img,
        i,
        current,
        lastCurrent,
        creative
    } = props;

    if(!img) return false;

    const promotionsClick = (item, position) => {
        if (typeof window !== 'undefined' && window.innerWidth <= 760) {
            let image_mobile = img.imagen_mobile || img.image_mobile;
            item.id = image_mobile ? image_mobile.split('/').pop() : '';
        } else {
            item.id = item.image ? item.image.split('/').pop() : '';
        }
        TagManagerService.promotionsClick(item, 'slot' + position, 'Banner Principal' + (creative ? creative : ''));
    };

    let image = img.image;

    let imageResponsive = {
        840: img.imagen_mobile || img.image_mobile,
        1440: img.image
    };

    let imageURL = img.url;
    let index = i + 1;
    
    return (
        <Link draggable="true" to={imageURL} target={img.url_target} onClick={() => promotionsClick(img, index)} className={'new-home-hero-slider-link' + (current === i ? ' current ' : '') + (lastCurrent === i ? ' last ' : '')}>
            {image && <ImageLoad srcSet={imageResponsive} src={image} alt={img.title || imageURL}/>}
        </Link>
    )
};

Item.propTypes = {
    img: PropTypes.object,
    i: PropTypes.number,
    current: PropTypes.number,
    lastCurrent: PropTypes.number,
    creative: PropTypes.string,
};


export default Item;
